export default __webpack_public_path__ + "static/media/img-c-00-btn-gtl.3315d90f.png";